// extracted by mini-css-extract-plugin
module.exports = {"avatar":"editAccount_avatar__2BOyk"};